import React from 'react';
import PurchasePlanReceipt from './PurchasePlanReceipt';
import messages from '../../../locale/jsonMessages';
import Layout from '../../../components/Layout/Layout';

export default function action({ store, params, intl }) {

    const title = intl?.formatMessage(messages.customerReceipt);
    const isAuthenticated = store.getState().runtime.isAuthenticated;
    let id = params?.id

    if (!isAuthenticated) return { redirect: '/login' };

    return {
        title,
        component:
            <Layout>
                <PurchasePlanReceipt id={id} title={title} />
            </Layout>,

    };
}
